import React from 'react'

const ButtonTertiary = ({ children, onClick, active, className = '', type = 'button', ...props }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`rounded-lg font-medium transition-all duration-200 text-xs px-3 py-1.5 bg-white border border-gray-300 text-gray-700 hover:bg-gray-50
        ${active
                    ? 'bg-primary-600 text-white shadow-md'
                    : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                }
        ${className}`}
            {...props}
        >
            {children}
        </button>
    )
}

export default ButtonTertiary

